import { clsx } from 'clsx';
import { forwardRef } from 'react';
import type { ForwardedRef, PropsWithChildren } from 'react';
import type { Simplify } from 'type-fest';
import { BaseText } from './BaseText';
import type { SupportedIntrinsicElements, TextProps } from './BaseText';
import { text } from './Text.css';

export const Text = forwardRef(
  <TElementType extends SupportedIntrinsicElements>(
    props: Simplify<PropsWithChildren<TextProps<TElementType>>>,
    ref: ForwardedRef<JSX.IntrinsicElements[TElementType]>,
  ): JSX.Element => {
    const { className, type, textTransform, textAlign } = props;
    const textClassName = clsx(text({ type, textTransform, textAlign }), className);

    return <BaseText {...props} className={textClassName} ref={ref} />;
  },
);

export type { TextVariants } from './Text.css';
